export default __webpack_public_path__ + "static/media/blockwhite.975a953f.svg";